import {
  V2ProjectResourceResource,
  useV2ListProjectResourcesForAccountQuery,
} from "@generated";

const useListProjectResources = (projectId) => {
  const { data, error, isLoading, refetch } =
    useV2ListProjectResourcesForAccountQuery({
      page: { size: 1000 },
      filter: { project: projectId, active: true },
    });

  let projectResources: V2ProjectResourceResource[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  if (data?.data) {
    try {
      projectResources = data?.data;

      if (!data?.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data?.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data?.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data?.meta["record-count"],
        pageCount: data?.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    projectResources,
    projectResourcesError: error || customError,
    projectResourcesLoading: isLoading,
    pageMeta,
    refetchProjectResources: refetch,
  };
};

export default useListProjectResources;
